import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Client } from '../../../core/types/client';
@Component({
    selector: 'itfg-client-mi',
    templateUrl: './client-mi.component.html',
    styleUrls: ['./client-mi.component.scss'],
    standalone: false
})
export class ClientMiComponent implements OnChanges, OnInit {
  @Input() client: Client;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

}
